import { AsyncPipe } from "@angular/common";
import { ChangeDetectionStrategy, Component, inject, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { map, Observable } from "rxjs";
import { DokumentUrlDTO } from "~app/pages/dokument/model/DokumentUrlDTO";

@Component({
    standalone: true,
    imports: [AsyncPipe],
    selector: "rask-dokument-arbetsorder-id",
    templateUrl: "../dokument-download.component.html",
    styleUrl: "../dokument-download.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DokumentArbetsorderIdComponent implements OnInit {
    protected dokumentUrl$: Observable<DokumentUrlDTO>;
    private readonly activatedRoute = inject(ActivatedRoute);

    ngOnInit(): void {
        this.dokumentUrl$ = this.activatedRoute.data.pipe(map(data => data.dokument));
    }
}
